const fragment = `
  id
  imageUrl
  isDefault
`;

export const listCommunityImagesQuery = `
  query ListCommunityImages(
    $filter: CommunityImageFilterInput
  ) {
    items: listCommunityImages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createCommunityImageQuery = `
  mutation CreateCommunityImage(
    $input: CreateCommunityImageInput!
    $image: Upload
  ) {
    item: createCommunityImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateCommunityImageQuery = `
  mutation UpdateCommunityImage(
    $input: UpdateCommunityImageInput!
    $image: Upload
  ) {
    item: updateCommunityImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteCommunityImageQuery = `
  mutation DeleteCommunityImage(
    $id: Int!
  ) {
    item: deleteCommunityImage(id: $id) {
      ${fragment}
    }
  }
`;

export const sortCommunityImagesQuery = `
  mutation SortCommunityImage(
    $communityId: Int!,
    $ids: [Int!]!
  ) {
    items: sortCommunityImages(communityId: $communityId, ids: $ids) {
      id
    }
  }
`;
